const TYPES = {
  ViewsService: Symbol.for('ViewsService'),
  ViewsListController: Symbol.for('ViewsListController'),
  StepsListController: Symbol.for('StepsListController'),
  CurvedMprController: Symbol.for('CurvedMprController'),
  ApproveController: Symbol.for('ApproveController'),
  NavigationButtonsController: Symbol.for('NavigationButtonsController'),
  AppController: Symbol.for('AppController'),
  ToastNotificationsController: Symbol.for('ToastNotificationsController'),
  NotificationsCenter: Symbol.for('NotificationsCenter'),
  ICineloopInfo: Symbol.for('ICineloopInfo'),
  PointsSwitcherController: Symbol.for('PointsSwitcherController'),
  IFrameController: Symbol.for('IFrameController'),
  ImporterFactory: Symbol.for('ImporterFactory'),
  IWasmModulesRegistry: Symbol.for('IWasmModulesRegistry'),
  IViewPortManagerBuilder: Symbol.for('IViewPortManagerBuilder'),
  ViewController: Symbol.for('ViewController'),
  ViewControllerProvider: Symbol.for('ViewControllerProvider'),
  TwoDLayerController: Symbol.for('ITwoDLayerController'),
  PlanningAlgorithm: Symbol.for('PlanningAlgorithm'),
  CasePhaseData: Symbol.for('CasePhaseData'),
  PlanningEntityRegistry: Symbol.for('PlanningEntityRegistry'),
  DynamicPlanningAlgorithmMediator: Symbol.for('DynamicPlanningAlgorithmMediator'),
  IPhasesCurveController: Symbol.for('IPhasesCurveController'),
  ICineloopControlController: Symbol.for('ICineloopControlController'),
  IndicationsResolver: Symbol.for('IndicationsResolver'),
  IStrategyByKindProvider: Symbol.for('IStrategyByKindProvider'),
  DiameterMeasurementsResolver: Symbol.for('DiameterMeasurementsResolver'),
  DistanceMeasurementsResolver: Symbol.for('DistanceMeasurementsResolver'),
  CommissurePointsResolver: Symbol.for('CommissurePointsResolver'),
  OrientationPresetsResolver: Symbol.for('OrientationPresetsResolver'),
  IObjectViewModelStore: Symbol.for('IObjectViewModelStore'),
  IViewFactoryProvider: Symbol.for('IViewFactoryProvider'),
  ISceneItemDetailsFactory: Symbol.for('ISceneItemDetailsFactory'),
  ObjectsListController: Symbol.for('ObjectsListController'),
  OrientationPresetsController: Symbol.for('OrientationPresetsController'),
  AreaDiametersController: Symbol.for('AreaDiametersController'),
  VariableDistancesBoxController: Symbol.for('VariableDistancesBoxController'),
  PapillaryIndicationController: Symbol.for('PapillaryIndicationController'),
  LeafletsIndicationController: Symbol.for('LeafletsIndicationController'),
  VariableDistanceCommandsFactory: Symbol.for('VariableDistanceCommandsFactory'),
  VariableDistanceMeasurementBoxResolver: Symbol.for('VariableDistanceMeasurementBoxResolver'),
  BoxIndicationStateStore: Symbol.for('BoxIndicationStateStore'),
  ImageSlicesListController: Symbol.for('ImageSlicesListController'),
  SynchronizeViewsController: Symbol.for('SynchronizeViewsController'),
  SynchronizeTabsController: Symbol.for('SynchronizeTabsController'),
  IMeasurementsBoxesController: Symbol.for('IMeasurementsBoxesController'),
  IBoxViewModelModifier: Symbol.for('IBoxViewModelModifier'),
  IndicationsBoxController: Symbol.for('IndicationsBoxController'),
  IObjectBoxesController: Symbol.for('IObjectBoxesController'),
  IViewItemsViewModelController: Symbol.for('IViewItemsViewModelController'),
  SavingStateController: Symbol.for('SavingStateController'),
  IViewPortControllerFactory: Symbol.for('IViewPortControllerFactory'),
  IIlluminator: Symbol.for('IIlluminator'),
  CaseInfoApi: Symbol.for('CaseInfoApi'),
  CaseFilesApi: Symbol.for('CaseFilesApi'),
  CaseDataProvider: Symbol.for('CaseDataProvider'),
  CasePersistenceHub: Symbol.for('CasePersistenceHub'),
  CasePersistenceRegistrar: Symbol.for('CasePersistenceRegistrar'),
  AppBootstrapper: Symbol.for('AppBootstrapper'),
  AuthInterceptor: Symbol.for('AuthInterceptor'),
  ViewOptionsController: Symbol.for('ViewOptionsController'),
  SurgeryRegistry: Symbol.for('SurgeryRegistry'),
  UIConfigResolver: Symbol.for('UIConfigResolver'),
  PresentationCreatorsRegistry: Symbol.for('PresentationCreatorsRegistry'),
  CustomCommissurePointsBoxController: Symbol.for('CustomCommissurePointsBoxController'),
  CustomCommissurePointsDescriptorResolver: Symbol.for('CustomCommissurePointsDescriptorResolver'),
  CustomCommissurePointsIndicationController: Symbol.for('CustomCommissurePointsIndicationController'),
  ThemeStore: Symbol.for('ThemeStore'),
  ICaseDataRepositoryFactory: Symbol.for('ICaseDataRepositoryFactory'),
  PackageInfoStore: Symbol.for('PackageInfoStore'),
  UserPreferencesStore: Symbol.for('UserPreferencesStore'),
  UserPreferencesPersistenceApi: Symbol.for('UserPreferencesPersistenceApi'),
  VisibilityLinkedVMController: Symbol.for('VisibilityLinkedVMController'),
  ViewOptionsCommandFactory: Symbol.for('ViewOptionsCommandFactory'),
  StepsListCommandsFactory: Symbol.for('StepsListCommandsFactory'),
  IdentifierTuneCommandsFactory: Symbol.for('IdentifierTuneCommandsFactory'),
  BooleanTuneCommandsFactory: Symbol.for('BooleanTuneCommandsFactory'),
  NumberTuneCommandsFactory: Symbol.for('  NumberTuneCommandsFactory'),
  OrientationPresetsCommandsFactory: Symbol.for('OrientationPresetsCommandsFactory'),
  DiametersCommandsFactory: Symbol.for('DiametersCommandsFactory'),
  ICommissureCommandsFactory: Symbol.for('ICommissureCommandsFactory'),
  UndoRedoButtonsController: Symbol.for('UndoRedoButtonsController'),
  WindowKeyboardShortcutController: Symbol.for('WindowKeyboardShortcutController'),
  EntitiesVisibilityTogglingService: Symbol.for('EntitiesVisibilityTogglingService'),
  WideAreaMeasurementConfigStrategy: Symbol.for('WideAreaMeasurementConfigStrategy'),
  WorkflowIndicationsResolver: Symbol.for('WorkflowIndicationsResolver'),
  IRemover: Symbol.for('IRemover'),
  AccentedQuadroViewLayoutController: Symbol.for('AccentedQuadroViewLayoutController'),
  SymmetricalQuadroViewLayoutController: Symbol.for('SymmetricalQuadroViewLayoutController'),
  IndicationColorSetter: Symbol.for('IndicationColorSetter'),
  QuadroLayoutStateStore: Symbol.for('QuadroLayoutStateStore'),
  QuadroLayoutController: Symbol.for('QuadroLayoutController'),
  CancellationController: Symbol.for('CancellationController'),
  BannerStore: Symbol.for('BannerStore'),
  BannerController: Symbol.for('BannerController'),
  BannerService: Symbol.for('BannerService')
};

export { TYPES };
